<template>
  <div v-if="show" class="modal-overlay" @click="handleOverlayClick">
    <div class="modal-content" @click.stop>
      <h2 class="modal-title">Delete Account</h2>
      <p class="modal-message">
        Are you sure you want to delete your account? This action cannot be undone.
      </p>
      <p class="modal-confirm-text">
        Type <i>{{ email }}</i> to confirm this deletion.
      </p>
      <input
        class="confirm-input"
        type="text"
        v-model="inputValue"
        @keyup.enter="tryConfirm"
        autocomplete="off"
        @paste.prevent
      />
      <div class="modal-actions">
        <button class="cancel-btn" @click="handleCancel">Cancel</button>
        <button class="delete-btn" :disabled="!canDelete" @click="handleConfirm">Delete Account</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteAccountModal',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    email: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      inputValue: ''
    }
  },
  computed: {
    canDelete() {
      return this.inputValue.trim() === `${this.email}`;
    }
  },
  methods: {
    handleCancel() {
      this.$emit('close');
    },
    handleConfirm() {
      if (this.canDelete) {
        this.$emit('confirm');
      }
    },
    handleOverlayClick() {
      this.$emit('close');
    },
    tryConfirm() {
      if (this.canDelete) this.handleConfirm();
    }
  },
  watch: {
    show(newVal) {
      if (newVal) this.inputValue = '';
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-title {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
}

.modal-message {
  color: #666;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.modal-confirm-text {
  color: #b71c1c;
  font-size: 1rem;
  margin-bottom: 1rem;
}

.confirm-input {
  width: 100%;
  padding: 0.7rem 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 1.5rem;
  font-size: 1rem;
  box-sizing: border-box;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.cancel-btn {
  padding: 0.75rem 1.5rem;
  border: 1px solid #ccc;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-btn:hover {
  background: #f5f5f5;
}

.delete-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  background: #d32f2f;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.delete-btn:disabled {
  background: #f2bcbc;
  color: #fff;
  cursor: not-allowed;
}

.delete-btn:hover:not(:disabled) {
  background: #b71c1c;
}
</style> 